import React from 'react';

import { FaDumbbell, FaHeart, FaUsers, FaUtensils } from 'react-icons/fa';

import { Heading5, Paragraph3 } from '@src/theme';
import { bemClassName } from '@src/utils/bem';

import { StyledAboutStatsSection } from './styles';

const b = bemClassName('about-stats-section');

const stats = [
  {
    icon: <FaUsers />,
    number: '50,000+',
    label: 'Active Users',
  },
  {
    icon: <FaDumbbell />,
    number: '1.2M+',
    label: 'Workouts Completed',
  },
  {
    icon: <FaUtensils />,
    number: '3.5M+',
    label: 'Meals Tracked',
  },
  {
    icon: <FaHeart />,
    number: '98%',
    label: 'Satisfaction Rate',
  },
];

const AboutStatsSection = () => {
  return (
    <StyledAboutStatsSection>
      <div className={b()}>
        <div className={b('inner')}>
          {stats.map((stat, index) => (
            <div key={index} className={b('stat')}>
              <div className={b('stat-icon')}>{stat.icon}</div>
              <Heading5>{stat.number}</Heading5>
              <Paragraph3>{stat.label}</Paragraph3>
            </div>
          ))}
        </div>
      </div>
    </StyledAboutStatsSection>
  );
};

export default AboutStatsSection;
